import { filterConstants } from '../utils/types';

export default function filterReducer(
  state = { [filterConstants.AREA_FILTER]: 0, courtsFilters: [] },
  action
) {
  switch (action.type) {
  case filterConstants.SET_FILTER:
    return { ...state, [action.filterName]: action.value };

  case filterConstants.SET_COURTS_FILTERS:
    return { ...state, courtsFilters: action.payload.courtsFilters };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/filterReducer.js